module.exports = __webpack_public_path__ + "img/member_coupons_icon_435001.6cb46136.png";